export const SITE = {
  name: "ProOne Solutions",
  domain: "https://www.proonesolutions.com",
};

export const IMAGES = {
  heroStudio: {
    url: "https://images.pexels.com/photos/6953663/pexels-photo-6953663.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    caption: "Why this picture: the ProOne production desk, where client audio and media are turned into finished work.",
    alt: "Professional recording studio desk with microphone and monitors",
  },
  transcription: {
    url: "https://images.pexels.com/photos/30229850/pexels-photo-30229850.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "Why this picture: transcription is listening craft — waveforms, timestamps, and careful ears.",
    alt: "Audio waveform on an editing screen used for transcription",
  },
  translation: {
    url: "https://images.unsplash.com/photo-1673515335152-f2589ba8bb7a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    caption: "Why this picture: translation is meaning rebuilt piece by piece — letter by letter when needed.",
    alt: "Letter tiles spelling the word translation",
  },
  media: {
    url: "https://images.unsplash.com/photo-1582198374945-39ac47df59b9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    caption: "Why this picture: the edit suite where films, reels, and brand stories are finished.",
    alt: "Video editing timeline on a post-production screen",
  },
  advertising: {
    url: "https://images.unsplash.com/photo-1712217559117-665e01ae5bc8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    caption: "Why this picture: campaigns are watched daily — spend, reach, and conversion on one board.",
    alt: "Digital marketing dashboard showing campaign metrics",
  },
  learnTutor: {
    url: "https://images.pexels.com/photos/6256136/pexels-photo-6256136.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1100",
    caption: "Why this picture: a live 1:1 lesson — the hour a learner gets a tutor's full attention.",
    alt: "Online tutoring session between a mentor and a student",
  },
  globalTranslation: {
    url: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
    caption: "Why this picture: your message crosses borders before it crosses desks — we make sure it arrives intact.",
    alt: "Earth at night with networks of light connecting cities",
  },
  mediaStory: {
    url: "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
    caption: "Why this picture: a promotional film mid-shoot — light, frame, and story working together.",
    alt: "Professional video camera on a tripod during a shoot",
  },
  digitalCampaign: {
    url: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
    caption: "Why this picture: optimisation is a habit — results reviewed before budgets move.",
    alt: "Laptop with analytics charts for an advertising campaign",
  },
  mathClass: {
    url: "https://images.unsplash.com/photo-1511629091441-ee46146481b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
    caption: "Why this picture: maths taught concept-first — formulas broken into logical steps.",
    alt: "Mathematics notes and formulas during a tutoring session",
  },
  cookingClass: {
    url: "https://images.unsplash.com/photo-1556910103-1c02745aae4d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
    caption: "Why this picture: cooking is learned by doing — technique, timing, and taste.",
    alt: "Hands preparing food in a cooking lesson",
  },
  artClass: {
    url: "https://images.unsplash.com/photo-1513364776144-60967b0f800f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
    caption: "Why this picture: art tracks run from first sketch to finished canvas.",
    alt: "Paint brushes and art supplies on a table",
  },
  ownership: {
    url: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
    caption: "Why this picture: every project has an owner, a checklist, and a paper trail.",
    alt: "Project documents and planning notes on a desk",
  },
  teamHands: {
    url: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    caption: "Why this picture: services are delivered by a small, accountable team — not a ticket queue.",
    alt: "Small team working together at a table with laptops",
  },
  impactHero: {
    url: "https://images.pexels.com/photos/15119089/pexels-photo-15119089.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
    caption: "Why this picture: learners at a partner tuition group in rural India. Village names are never published.",
    alt: "Children studying together in a rural learning group in India",
  },
  impactMedical: {
    url: "https://images.unsplash.com/photo-1708593330411-24d85eff0728?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
    caption: "Why this picture: a community health gathering — checkups travel to the village, not the other way round.",
    alt: "Community health workers at a rural wellness gathering",
  },
  impactEducation: {
    url: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
    caption: "Why this picture: a book, a uniform, a fee paid on time — small things that keep a child in class.",
    alt: "Hands of an adult and a child with learning materials",
  },
  impactRelief: {
    url: "https://images.unsplash.com/photo-1609252509229-364936a1d1a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
    caption: "Why this picture: relief is logistics under pressure — food, warmth, and medicine moved fast.",
    alt: "Volunteers coordinating relief supplies",
  },
  impactCommunity: {
    url: "https://images.unsplash.com/photo-1665649998055-bbd272dacad7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
    caption: "Why this picture: local leadership circles decide what gets built — we help deliver it.",
    alt: "Community members in a local leadership meeting",
  },
  impactLanguage: {
    url: "https://images.pexels.com/photos/35152622/pexels-photo-35152622.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "Why this picture: a health pamphlet only works if it is written in the language the village speaks.",
    alt: "Facilitator guiding elders through translated documents",
  },
  aboutSupplies: {
    url: "https://images.unsplash.com/photo-1593113598332-cd288d649433?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    caption: "Why this picture: packing supplies before a field visit — the unglamorous middle of community work.",
    alt: "Volunteers packing donated supplies into boxes",
  },
  contactPhone: {
    url: "https://images.unsplash.com/photo-1423666639041-f56000c27a9a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
    caption: "Why this picture: a real person reads every message. Expect a reply, not an autoresponder.",
    alt: "A phone and notebook on a desk",
  },
};

export const SERVICES = [
  {
    id: "transcription",
    index: "01",
    title: "Transcription",
    promise: "Audio and video into clear, usable text",
    link: "/services#transcription",
    img: IMAGES.transcription,
  },
  {
    id: "translation",
    index: "02",
    title: "Translation",
    promise: "Your message, accurate in every market",
    link: "/services#translation",
    img: IMAGES.translation,
  },
  {
    id: "media",
    index: "03",
    title: "Media Content",
    promise: "Films, reels, and branded stories that get watched",
    link: "/services#media",
    img: IMAGES.media,
  },
  {
    id: "advertising",
    index: "04",
    title: "Digital Advertising",
    promise: "Campaigns on Google, Meta, and YouTube",
    link: "/services#advertising",
    img: IMAGES.advertising,
  },
  {
    id: "learn",
    index: "05",
    title: "Learn",
    promise: "Flexible video + 1:1 tuition in Maths, Cooking, Art",
    link: "/learn",
    img: IMAGES.learnTutor,
  },
];

export const MARQUEE_ITEMS = [
  "Transcription",
  "Multilingual Translation",
  "Media Production",
  "Digital Campaigns",
  "Mathematics",
  "Cooking",
  "Fine Art",
  "Rural Healthcare",
  "Education Support",
  "Community Relief",
];

export const CHARTS = [
  {
    id: "attainment",
    src: "/charts/image6.png",
    title: "Educational attainment of adults (25+), India (~2023)",
    caption:
      "Spoken plainly: about 1 in 4 adults has no formal schooling, the largest share stopped at primary, roughly 1 in 3 reached secondary, and about 1 in 10 reached higher education.",
  },
  {
    id: "rural-urban-literacy",
    src: "/charts/image5.png",
    title: "Urban vs rural literacy",
    caption:
      "Spoken plainly: literacy is 88.9% in cities but 77.5% in rural areas. That eleven-point gap is where our learning support works.",
  },
  {
    id: "literacy-overall",
    src: "/charts/image3.png",
    title: "India literacy, overall (2023–24)",
    caption:
      "Spoken plainly: about one in five Indians cannot read or write — and most of them live in rural districts.",
  },
  {
    id: "gender-literacy",
    src: "/charts/image4.png",
    title: "Male–female literacy and illiteracy (2023–24)",
    caption:
      "Spoken plainly: the gap falls hardest on women and girls — 12.7% female illiteracy against 6.4% male. Tuition centres and women's groups answer this directly.",
  },
  {
    id: "poverty",
    src: "/charts/image8.png",
    title: "Poverty in India: people living on less than $3.65 a day",
    caption:
      "Spoken plainly: around 600 million people live under $3.65 a day. At the stricter rural line, need concentrates in the villages we serve.",
  },
  {
    id: "financial-standing",
    src: "/charts/image1.png",
    title: "India financial standing",
    caption:
      "Spoken plainly: seven of ten households are lower-income. A school fee or a clinic bill is not a line item — it is a decision about the future.",
  },
  {
    id: "nutrition",
    src: "/charts/image7.png",
    title: "Nutritional status of children under five in India",
    caption:
      "Spoken plainly: roughly one in three young children is undernourished. Clinics pair treatment with maternal education and hygiene kits.",
  },
  {
    id: "faiths",
    src: "/charts/image2.png",
    title: "Estimated religious composition of India (2024–2025)",
    caption:
      "Spoken plainly: India is home to many faiths and cultures. Our field work is not organized by religion. It is organized by need.",
  },
];

export const IMPACT_STATS = [
  {
    metric: "27.7% / 14.3%",
    label: "Rural vs urban poverty",
    caption: "At the World Bank $4.20/day line — need is nearly twice as concentrated in rural India.",
  },
  {
    metric: "102 of 123",
    label: "2025 Global Hunger Index",
    caption: "India's rank, with a score of 25.8 — classed as serious.",
  },
  {
    metric: "~1 / 10,000",
    label: "Rural doctor density",
    caption: "In many districts a single doctor serves a small town's worth of villages.",
  },
  {
    metric: "2,262",
    label: "People groups",
    caption: "Many rural communities remain underserved by clinics, schools, and information.",
  },
  {
    metric: "~8,000",
    label: "Villages without a school",
    caption: "Reported in Maharashtra alone — one state, one example of the gap.",
  },
];

export const PROGRAMS = [
  {
    id: "clinics",
    index: "01",
    title: "Community medical clinics",
    lead: "No-cost care for families who cannot pay.",
    body: "Checkups, basic treatment, maternal care, hygiene camps, water filters, menstrual education, and hygiene kits.",
    img: IMAGES.impactMedical,
  },
  {
    id: "learning",
    index: "02",
    title: "Learning support",
    lead: "We remove cost barriers when they block school.",
    body: "Tuition centres, school-fee help when a child would otherwise drop out, books, stationery, and uniforms.",
    img: IMAGES.impactEducation,
  },
  {
    id: "relief",
    index: "03",
    title: "Emergency and one-time help",
    lead: "Fast, specific, and gone when the crisis is.",
    body: "Food, clothing, winter warmth, widow and orphan support, COVID rations and oxygen, flood rehabilitation, a rooftop, relocation, a toilet where there was no safe sanitation.",
    img: IMAGES.impactRelief,
  },
  {
    id: "development",
    index: "04",
    title: "Community development",
    lead: "Built with the community, not for the camera.",
    body: "Clean water, sewing centres, women's groups, and hygiene and reproductive-health sessions taught with dignity.",
    img: IMAGES.impactCommunity,
  },
  {
    id: "language",
    index: "05",
    title: "Language access",
    lead: "Field examples, not a sales pitch.",
    body: "Hindi/Bundeli ORS and maternal-warning pamphlets; Marathi/Hindi flood alerts; Tamil/Telugu parent sheets; Bengali/Gujarati ration-rights explainers; clinic signage in the village language.",
    img: IMAGES.impactLanguage,
  },
];
